import React from 'react';
import { Tooltip } from '@mui/material';
import type { LifecycleGroup } from '@features/lifecycles/lifecycle-groups.data';

type LifecycleGroupTooltipProps = {
  group: LifecycleGroup;
  active: boolean;
  lifetimeHovered: boolean;
  children: React.ReactElement;
  placement?: 'top' | 'bottom';
};

export const LifecycleGroupTooltip: React.FC<LifecycleGroupTooltipProps> = ({
  group,
  active,
  lifetimeHovered,
  children,
  placement = 'top',
}) => (
  <Tooltip
    title={
      group.id === 'operation' && active && lifetimeHovered
        ? ''
        : group.description
    }
    describeChild
    placement={placement}
    slotProps={{
      popper: {
        modifiers: [{ name: 'offset', options: { offset: [0, 8] } }],
      },
    }}
  >
    {children}
  </Tooltip>
);
